/**
 *
 * Multistep Form UI
 *
 * UI for handling the logic for showing the multistep form journey
 * NOTE: the logic of this form varies enough that it made sense to separate
 * from contact-download_form.js
 */

const $ = require( 'jquery' );
const _Forms = require('../../utilities/_form-controller.js');
const Deckable2 = require( '../../utilities/deckable2.js' );
const { Foundation, dataLayer } = window;
const _ = require("lodash");
const AbandonedForm = require('../../utilities/AbandonedForm');
const submitFormToGoogleSheets = require('../../utilities/submitFormToGoogleSheets');
const getIterableBackendUrl = require("../../common/getIterableBackendUrl");
const kickboxCheck = require('../../src/run/kickbox/kickboxCheck');
const disableSubmitButtonInForm = require('../../src/run/form/disableSubmitButtonInForm');
const enableSubmitButtonInForm = require('../../src/run/form/enableSubmitButtonInForm');
const isFoundationFormValid = require('../../src/run/form/isFoundationFormValid');

module.exports = class ContactSalesForm {
    constructor(el){
        this.$el = $(el);
        this.$form = this.$el.find('.itbl-b-form');
        this.FormInstance = new Foundation.Abide(this.$form);

        //special inputs that need to be watched for
        this.$emailInput = this.$el.find( '[name=Email]' );
        this.$marketingConsent = this.$form.find('[name=marketingConsent]');
        this.$privacyPolicy = this.$form.find('#iterables-privacy-policy');
        this.$countrySelect = this.$form.find('.itbl-b-select__country');

        //success message SVG classes
        this.$confirmation = this.$el.find('.itbl-c-form__confirmation');
        this.$confirmationWrap = this.$el.find('.itbl-b-form__confirmation-overflow');

        this.APIState = Object.assign(
            {},
            {
                wp_email_to: 'forms@iterable.com',
                wp_email_subject: document.title,
                wp_email_message: null, //we gotta build this message body
                listUpload: true,
            }
        );

        this.canSubmit = false;

        //init the deckable class and turn on the loading spinner
        this.deckable = new Deckable2(this.$el, {}).showHideLoading(true);

        this.events();

        this.kickboxCheck = this.kickboxCheck.bind(this);

        this.APIState.Email_Verification_Status__c = '';
        this.APIState.kickboxReason = '';
        this.$emailInput.on('change', e => {
            void this.kickboxCheck($(e.currentTarget).val());
            this.onEmailAndCountryEntered();
        });

        this.$countrySelect.on('change', () => this.onEmailAndCountryEntered());

        this.deckable.goToDeck('form');

        this.abandonedForm = new AbandonedForm(this.$form);

        this.$form.find('input,textarea,select').on("change", () => {
            void this.abandonedForm.send(false);
        });

        this.isRecaptchaEnabled = window.ITBL.google_recaptcha_version !== "disabled";

        const isRecaptchaChallengeVisible = () => {
            const $iframe = $('iframe[title*="recaptcha"]');
            return $iframe.length && $iframe[0].style.width !== "100%";
        };

        let interval = undefined;
        let recaptchaChallengeAppeared = false;
        if (this.isRecaptchaEnabled) {
            interval = setInterval(async () => {
                if (isRecaptchaChallengeVisible()) {
                    recaptchaChallengeAppeared = true;
                    clearInterval(interval);
                    interval = undefined;

                    const APIState = this.APIState;

                    try {
                        submitFormToGoogleSheets({
                                'JSON Payload': JSON.stringify(APIState, null, 2),
                                Email: APIState.Email,
                                FirstName: APIState.FirstName,
                                LastName: APIState.LastName,
                                Company: APIState.Company,
                                Company_Size_Range__c: APIState.Company_Size_Range__c,
                                Country: APIState.Country,
                                State: APIState.State,
                                marketingConsent: APIState.marketingConsent,
                                URL: window.location.href,
                                _mktoReferrer: APIState._mktoReferrer,
                                formVid: APIState.formVid,
                                munchkinId: APIState.munchkinId,
                                _mkt_trk: APIState._mkt_trk,
                                HQ_Country__c: APIState.HQ_Country__c,
                                HQ_State__c: APIState.HQ_State__c,
                                Marketing_Channels__c: APIState.Marketing_Channels__c,
                                Email_Sends_per_Month_Range__c: APIState.Email_Sends_per_Month_Range__c,
                                demoRequestNotesImport: APIState.demoRequestNotesImport,
                                demoRequestEmailProvider: APIState.demoRequestEmailProvider,
                                Phone: APIState.Phone,
                                Email_Verification_Status__c: APIState.Email_Verification_Status__c,
                                kickboxReason: APIState.kickboxReason,
                                Locale__c: APIState.Locale__c,
                                Primary_Use_Case__c: APIState.Primary_Use_Case__c,
                                formid: APIState.formid,
                                LOG_TYPE: "RECAPTCHA_CHALLENGE",
                            }
                        );
                    } catch (e) {
                        // Do nothing
                    }
                }
            }, 300);
        }

        const verifyRecaptchaToken = async (token) => {
            let challengeVerified;
            try {
                const verifyUrl = getIterableBackendUrl() + "/wp-json/itblbackend/v1/recaptcha-verify";
                const res = await fetch(verifyUrl, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({token})
                });

                const resJson = await res.json();

                challengeVerified = resJson.success;
            } catch (e) {
                console.error("Could not verify the Google reCAPTCHA token!");
                challengeVerified = true;
            }

            return challengeVerified;
        };

        const initRecaptcha = () => {
            if (window.grecaptcha && window.grecaptcha.render) {
                const $submitButton = this.$form.find('[type="submit"]');

                if ($submitButton.length) {
                    const submitButton = $submitButton[0];

                    const widgetId = window.grecaptcha.render(submitButton, {
                        sitekey: window.ITBL.google_recaptcha_invisible_v2_site_key,
                        callback: async (token) => {
                            if (interval) {
                                clearInterval(interval);
                                interval = undefined;
                            }

                            this.APIState.recaptchaChallenge = recaptchaChallengeAppeared;

                            const recaptchaTokenVerified = await verifyRecaptchaToken(token);

                            if (recaptchaTokenVerified) {
                                const isValid = isFoundationFormValid(this.$form);

                                if (isValid) {
                                    await this.event__validForm();
                                }
                            } else {
                                enableSubmitButtonInForm(this.$form[0]);
                            }
                            window.grecaptcha.reset(widgetId);
                        },
                        'expired-callback': (x) => {
                          console.log("Expired", x);
                        }
                    });
                }
            } else {
                setTimeout(() => initRecaptcha(), 300);
            }
        };

        if (this.isRecaptchaEnabled) {
            initRecaptcha();
        }
    }

    async kickboxCheck (email) {
        const kickboxResponse = await kickboxCheck(email);
        this.APIState.Email_Verification_Status__c = kickboxResponse.result;
        this.APIState.kickboxReason = kickboxResponse.reason;
    }

    events(){
        this.$form
            .on('submit', e => {
                e.preventDefault()

                if (!this.canSubmit) {
                    console.log('No submitting allowed')
                    return false
                }

                disableSubmitButtonInForm(this.$form[0]);

                if (!this.isRecaptchaEnabled) {
                    void this.event__validForm(); // This triggers the form submission
                }
            })
            .on('forminvalid.zf.abide', ()=>{
                window.$form = this.$form;

                const $inputWraps = this.$form.find('.itbl-b-form__input-wrap');

                $inputWraps.each(function () {
                    const $input = $(this).find('[name]');
                    if (_.isEmpty($input.val())) {
                        $(this).removeClass('hidden');
                        $(this).removeClass('d-none');
                    }

                    $input.attr("data-hasusertyped", "true");
                });

                dataLayer.push({'event': 'FormSubmissionFallback'});

                this.canSubmit = false;
            })
            // field element is invalid
            .on("invalid.zf.abide", ()=> {
            })
            // field element is valid
            .on("valid.zf.abide", ()=>{
            })
            .on('formvalid.zf.abide', ()=>{
                this.canSubmit = true;
            });
    }

    triggerProcess( target ){

        if( !( target ) ){
            console.log( 'No target provided' );
            return;
        }

        //create the net instance of the event and assign it to be watched by the Process script
        let event = new Event("itblProcess.goToStep", {
            bubbles: true,
        });

        //update the target information, that the process script needs to locate it's target
        event.detail = {
            target: target
        };

        //dispatch
        this.$el[0].dispatchEvent(event);
    }

    async event__validForm() {
        this.deckable.hideAllDecks();

        //serialize this data into name/value
        await _Forms.helper__addFormInputsToState(this.$form, this.APIState);

        if (!this.APIState.Email_Verification_Status__c) {
            try {
                await this.kickboxCheck(this.APIState.Email);
            } catch (e) {
                console.error("Kickbox error", e);
            }
        }

        //we have to manually check for this field to be checked
        if (this.$privacyPolicy.is(':checked')) {
            this.APIState.marketingConsent = 'true';
            this.$marketingConsent.val('true');
        } else {
            //if checkbox is not checked, explicitly set value to false as string, this will be converted into boolean by JSON
            this.APIState.marketingConsent = 'false';

        }

        //setup all encrypted values in localstorage
        _Forms.helper__setAllEncryptedVals(
            ['FirstName', 'LastName', 'Email', 'Phone', 'marketingConsent'],
            this.APIState
        );

        // NOTE: Something sets the State to "; ". This needs to be stripped to ""!!
        if (this.APIState.HQ_State__c === "; ") {
            this.APIState.HQ_State__c = "";
        }

        if (this.APIState.State === "; ") {
            this.APIState.State = "";
            this.$form.find("[name=State]").val(this.APIState.State);
        }

        if (!this.APIState.HQ_Country__c && !this.APIState.HQ_State__c) {
            this.APIState.HQ_Country__c = this.APIState.Country;
            this.APIState.HQ_State__c = this.APIState.State;
        }

        if (!_.includes(
            ["United States", "Canada"],
            this.APIState.HQ_Country__c
        )) {
            this.APIState.HQ_State__c = "";
        }

        this.$form.find("[name=HQ_Country__c]").val(this.APIState.HQ_Country__c);
        this.$form.find("[name=HQ_State__c]").val(this.APIState.HQ_State__c);

        disableSubmitButtonInForm(this.$form[0]);

        // chiliPiperFormId: "demo" - Take a look inside _form-controller.js to figure out why.
        // The form id is being overwritten with the data-formtype. This is probably because of Setka 1122 forms.
        const chilipiperId = this.$form.attr("data-chilipiper-id");
        _Forms.marketo__submit(this.APIState, false, {chiliPiperFormQuery: `[data-chilipiper-id="${chilipiperId}"]`}, this.$form)
            .then(() => {
                //trigger Google Tag Manager event for Adwords conversion here!
                dataLayer.push({'event': 'ajaxFormSubmitted'});
                this.abandonedForm.send(true);
            })
            .catch(e => {
                console.log(e);
            })
            .finally(() => {
                //disallow forms to submit again
                this.canSubmit = false;

                _Forms.debug( 'finished API state', this.APIState );

                //even though this submission failed, we are jumping to success anyway
                this.deckable
                    .goToDeck('confirmation');

                //trigger the finish slide: the finished deck is #2
                this.triggerProcess( 2 );
            });

        return false;
    }

    onEmailAndCountryEntered() {
        const email = this.$el.find('[name="Email"]').val();
        const country = this.$el.find('[name="Country"]').val();

        if (!_.isEmpty(email) && !_.isEmpty(country)) {
            this.$el.find('[name="FirstName"]').parent().removeClass('d-none');
            this.$el.find('[name="LastName"]').parent().removeClass('d-none');
            this.$el.find('[name="Company"]').parent().removeClass('d-none');
            this.$el.find('[name="Phone"]').parent().removeClass('d-none');
            this.$el.find('[name="Email_Sends_per_Month_Range__c"]').parent().removeClass('d-none');
            this.$el.find('[name="demoRequestEmailProvider"]').parent().removeClass('d-none');
            this.$el.find('[name="demoRequestNotesImport"]').parent().removeClass('d-none');

            if (country !== "United States") {
                this.$el.find('#opt-in-consent').removeClass('d-none');
                this.$el.find('[name="marketingConsent"]').prop("checked", false);
                this.$el.find('[name="marketingConsent"]').parent().removeClass('d-none-important');
            } else {
                this.$el.find('#opt-in-consent').removeClass('d-none');
                this.$el.find('[name="marketingConsent"]').prop("checked", false);
                this.$el.find('[name="marketingConsent"]').parent().addClass('d-none-important');
            }
        }
    }
}
